// This file has all the event keys required in our application
// The eventKeys are used to send/recieve data between components

export class pubsubEvents {
  public static eventKeys = {
    APP_START: "app:start",
    CREATE_WIDGETS_SUCCESS: "create:widgets::success",
    DELETE_WIDGETS_SUCCESS: "delete:widgets::success",
    SHOW_CARD_SELECTOR: "show:card:selector",
    TOGGLE_DOCKED_WORKSPACE: "toggle:docked:workspace",
    TOGGLE_NAV_DRAWER: "toggle:drawer:nav",
    REMOVE_ALL_CARDS: "remove:all:cards",
    SHOW_TAB_WORKSPACE: "show:tab:workspace",
    DISPLAY_WORKSPACE_ALERT: "show:workspace.alert",
    DISPLAY_EXTERNAL_WORKSPACE_ALERT: "show:workspace.external.alert",
    HIDE_EXTERNAL_WORKSPACE_ALERT: "hide:workspace.external.alert",
    MOBILE_BREAKPOINT: "breakpoint:cme-small-display",
    DESKTOP_BREAKPOINT: "breakpoint:cme-medium-display",
    UPDATE_MENU_STATE: "menu:update",
    HEARTBEAT_STOP: "heartbeat:stop",
    HEARTBEAT_ARREST: "heartbeat:arrest",
    HEARTBEAT_START: "heartbeat:start",
    LOGOFF: "app:logoff",
    LOGOFFDIRECT: "app:logoffDirect",
    UPDATE_NAV_CARD_STATE: "nav:update-card-state",
    TRIGGER_NAV_ITEM: "nav:trigger-card",
    SHOW_ORDER_DETAIL: "orders:show-detail",
    DISPOSE_ANY_CARD_OVERLAYS: "cards:overlays:dispose",
    UNCHECK_COLUMN_PREFERENCES: "datatables:uncheck-column-preferences",
    CMED_USER_SELECTED: "cmed:user:selected",
    CLOSE_MODAL: "close:modal",
    ADD_WIDGET: "platform:add:widget",
    CARD_RESIZED: "card:resized",
    CARD_RESIZED_CLICK: "card:resized:click",
    WINDOW_RESIZED: "window:resized",
    ADD_VENDOR_CONTRACTS: "cmed:add:vendor-data",
    WORKSPACE_START: "workspace.start",
    WORKSPACE_UPDATE: "workspace.update",
    UPDATE_MOBILE_NAV_ACTIVE_CARD: "mobile:navigation:cards:update:activecard",
    CARD_EDITNAME_ACCEPT: "card:editname:accept",
    CARD_EDITNAME_REJECT: "card:editname:reject",
    CARD_EDITNAME: "card:editname",
    VISIBILITY_CHANGE: "visibility:change",
    BULK_ACTION_COMPLETE: "BULK_ACTION_COMPLETE",
  };
  public static platformEvents = {
    UPDATE_USER_REGION: "platform:region:user_update",
  };
  public static socketKeys = {
    CONNECTED_WEBSOCKET: "socket:app:connected",
    RECONNECTED_WEBSOCKET: "socket:app:reconnected",
    SET_RECONNECTING_STATE_TRUE: "socket:status:reconnected",
    ATTEMPT_RECONNECT: "socket:app:reconnecting",
    ATTEMPT_VISIBILITY_RECONNECT: "socket:app:visibility:reconnecting",
    LOGIN_SUCCESS: "socket:login:success",
    SET_PREFERENCES: "socket:set:preferences",
    PREFERENCES_SUCCESS: "socket:success:preferences",
    GET_FULL_NAME_SUCCESS: "socket:success:getFullName",
    GET_SAVED_CMEDFILTER: "socket:success:getsavedfilter",
    UPDATE_SAVED_CMEDFILTER: "socket:success:updatecmedfilter",
    SAVE_SAVED_CMEDFILTER: "socket:success:savecmedfilter",
    DELETE_SAVED_CMEDFILTER: "socket:success:deletecmedfilter",
    SET_WORKSPACES_START_APP: "socket:workspaces:start",
    SAVE_WORKSPACES_SUCCESS: "socket:workspaces:success",
    PENDING_ORDER_STATUS: "socket:order:update:status",
    SET_ENTITLEMENTS_START_APP: "socket:set:entitlements",
    FS_ORDER_SEARCH_SUCCESS: "socket:fs-order-search:success",
    FS_SEARCH_FAVOURITES_SUCCESS: "socket:fs.search.favourites:success",
    FS_SEARCH_FAVOURITES_SAVE_SUCCESS:
      "socket:fs.search.favourites.save:success",
    FS_SEARCH_FAVOURITES_EDIT_SUCCESS:
      "socket:fs.search.favourites.edit:success",
    FS_SEARCH_FAVOURITES_DELETE_SUCCESS:
      "socket:fs.search.favourites.delete:success",
    FS_AGG_FILLS_SEARCH_SUCCESS: "socket:fs-agg-fills-search:success",
    FS_TRADE_FILLS_SEARCH_SUCCESS: "socket:fs-trade-fills-search:success",
    FS_SEARCH_INPUTS_SUCCESS: "socket:fs-search-inputs:success",
    FS_CANCEL_HISTORY_MQ_SUCCESS: "socket:fs-cancellation-history-mq:success",
    FS_CANCEL_HISTORY_ORDER_SUCCESS:
      "socket:fs-cancellation-history-order:success",
    FS_FIRM_MQC_SUCCESS: "socket:fs-firm-mqc:success",
    FS_ORDER_CANCEL_COMPLETE: "socket:fs-order-cancel:complete",
    FS_ORDER_CANCEL_ALL_COMPLETE: "socket:fs-order-cancel-all:complete",
    FS_ORDER_DETAILS_SUCCESS: "socket:fs-order-details:success",
    FS_HANDLE_ENTITLEMENTS_FAIL: "socket:fs-search-inputs:error",
    FS_HANDLE_IMPERSONATION_FAIL: "socket:fs-search-impersonation:error",
    FS_GET_NIGHTLY_REPORTS_SUCCESS: "socket:fs-nightly-reports:success",
    CMED_ORDER_ENTRY_RESPONSE: "cmed:order.entry.criteria",
    CMED_PRICE_TICKS_RESPONSE: "cmed:get.price.ticks.response",
    HANDLE_SOCKET_ERROR: "socket:error",
    HANDLE_REQUEST_ERROR: "request:error",
    CLOSED_WEBSOCKET: "socket:closed",
    UPDATE_CANCELLATION_HISTORY: "cancellationHistory:massquote:refresh",
    UPDATE_ORDER_CANCELLATION_HISTORY: "cancellationHistory:order:refresh",
    CMED_ORDER_ENTRY_REQUEST: "cmed:order.entry.request",
    CMED_NEW_ORDER_SUCCESS: "cmed:new.order.success",
    CMED_AGGRESSION_ORDER_SUCCESS: "cmed:aggression.order.success",
    CMED_ALL_PRODUCTS_SUCCESS: "cmed:contracts.products.success",
    CMED_ALL_PRODUCTS_FAILURE: "cmed:contracts.products.failure",
    CMED_STRATEGIES_SUCCESS: "cmed:contracts.strategies.success",
    CMED_STRATEGIES_FAILURE: "cmed:contracts.strategies.failure",
    CMED_ALL_CONTRACTS_SUCCESS: "cmed:contracts.all.success",
    CMED_ALL_CONTRACTS_FAILURE: "cmed:contracts.all.failure",
    CMED_ADD_CONTRACTS_SUCCESS: "cmed:contracts.add.success",
    CMED_ADD_CONTRACTS_FAILURE: "cmed:contracts.add.failure",
    CMED_ALL_STRIKES_SUCCESS: "cmed:contracts.strikes.success",
    CMED_ALL_PERIODS_SUCCESS: "cmed:contracts.periods.success",
    CMED_ALL_PERIODS_FAILURE: "cmed:contracts.periods.failure",
    CMED_CONTRACT_REMOVED_SUCCESS: "cmed:contracts.removed.success",
    PLATFORM_SERVICE_OUTAGE: "platform:service:outage",
    CMED_UNDERLYING_SUCCESS: "cmed:underlying.success",
    CMED_UNDERLYING_FAILURE: "cmed:underlying.failure",
    CMED_OPTIONSGRID_EXPIRY_SUCCESS: "cmed:optionsgrid.expiry.success",
    CMED_OPTIONSGRID_EXPIRY_FAILURE: "cmed:optionsgrid.expiry.failure",
    CMED_OPTIONSGRID_FIND_OPTIONS_SUCCESS:
      "cmed:optionsgrid.find.options.success",
    CMED_OPTIONSGRID_FIND_OPTIONS_FAILURE:
      "cmed:optionsgrid.find.options.failure",
    CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER_SUCCESS:
      "cmed:optionsgrid.subscribe.strikeladder.success",
    CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER_FAILURE:
      "cmed:optionsgrid.subscribe.strikeladder.failure",
    CMED_OPTIONSGRID_UNDERLYING_FUTURE_SUCCESS:
      "cmed:optionsgrid.underlying.future.success",
    CMED_OPTIONSGRID_UNDERLYING_FUTURE_FAILURE:
      "cmed:optionsgrid.underlying.future.failure",
    CMED_OPTIONSGRID_MARKET_DATA_SUCCESS:
      "cmed:optionsgrid.market.data.success",
    CMED_OPTIONSGRID_MARKET_DATA_FAILURE:
      "cmed:optionsgrid.market.data.failure",
    CMED_OPTIONSGRID_FETCH: "cmed:optionsgrid.fetch.data.from.db",
    CMED_OPTIONSGRID_SAVE_SUCCESS: "cmed:optionsgrid.save.data.to.db.success",
    CMED_OPTIONSGRID_DELETE: "cmed:optionsgrid.delete.data.from.db",
    GET_TRENDSPIDER_CHART_URL_SUCCESS: "cmed:get.trendspider.chart.url.success",
    CORE_REQUESTED_ALERTS_UPDATE: "core:requested-alerts:update",
    CORE_TRIGGERED_ALERTS_UPDATE: "core:triggered-alerts:update",
    CORE_ALERT_START_SUCCESS: "core:alert:start:success",
    CORE_ALERT_START_FAILURE: "core:alert:start:failure",
    CORE_ALERT_EDIT_SUCCESS: "core:alert:edit:success",
    CORE_ALERT_EDIT_FAILURE: "core:alert:edit:failure",
    CORE_ALERT_PAUSE_SUCCESS: "core:alert:pause:success",
    CORE_ALERT_PAUSE_FAILURE: "core:alert:pause:failure",
    CORE_ALERT_RESUME_SUCCESS: "core:alert:resume:success",
    CORE_ALERT_RESUME_FAILURE: "core:alert:resume:failure",
    CORE_ALERT_DELETE_SUCCESS: "core:alert:delete:success",
    CORE_ALERT_DELETE_FAILURE: "core:alert:delete:failure",
    CORE_GET_FRACTIONAL_TYPE_SUCCESS: "core:get.fractional.type:success",
    CORE_GET_FRACTIONAL_TYPE_FAILURE: "core:get.fractional.type:failure",
    CHECK_BEACON_ACCESS_SUCCESS: "core:check.beacon.access:success",
    CHECK_BEACON_ACCESS_FAILURE: "core:check.beacon.access:failure",
    GET_BLOCK_FILTER_SUCCESS: "block:filter.get.success",
    UPDATE_BLOCK_FILTER_SUCCESS: "block:filter.update.success",
    DELETE_BLOCK_FILTER_SUCCESS: "block:filter.delete.success",
    CREATE_BLOCK_FILTER_SUCCESS: "block:filter.create.success",
  };
  public static stompSubscriptionKeys = {
    CORE: "core",
    CMED_USER_ACCOUNTS: "cmed:user:accounts",
    Block_FEED_HISTORICAL_DATA: "blockfeed:initial:data",
    CONTRACT_MARKET_DATA: "cmed:contract.market.data.update",
    ORDER_CANCELLATIONS: "async:orders.cancellations.update",
    CMED_USER_LOGON_RESPONSE_SUCCESS: "cmed:user:logon:response:success",
    CMED_LOGIN_SELECTION_NEEDED: "cmed:user:logon:loginselectionneeded:success",
    CMED_POST_LOGIN_USER_ACCOUNTS: "cmed-service:cmed:user:post:accounts",
    CMED_USER_LOGON_SUCCESS: "cmed:user:logon:success",
    CMED_USER_LOGON_FAILED: "cmed:user:logon:failed",
    CMED_ORDER_UPDATES: "cmed:order.updates",
    CMED_ORDER_INSTRUMENTS_UPDATE: "cmed:order.instrument.updates",
    CMED_ORDER_DETAILS_UPDATE: "cmed:order.details.update",
    CMED_ORDER_FILLS_UPDATE: "cmed:order.fills.update",
    CMED_ORDER_MARKET_DATA_UPDATE: "cmed:order.market-data.update",
    CMED_ORDER_BID_OFFERS_UPDATE: "cmed:order.bid-offers.update",
    CMED_ORDER_USER_DETAILS_UPDATE: "cmed:user.details.update",
    CMED_ORDER_ACTION_ACTIVATE: "cmed:order.action.activate",
    CMED_TRADING_GRID_GROUPS_UPDATE: "cmed:trading.grid.groups.update",
    CMED_TRADING_GRID_GROUP_ITEM_UPDATE: "cmed:trading.grid.group.item.update",
    CMED_OPTIONSGRID_GROUP: "cmed:options.grid.update:group",
    CMED_OPTIONSGRID_GROUP_ITEM: "cmed:options.grid.update:group.item",
    CMED_POSITION_AGGREGATES_UPDATE: "cmed:position.aggregates.update",
    ALERTING_STATUS_UPDATE: "alerting:status.update",
  };
  public static errorKeys = {
    CMED_ERROR_TOAST: "cmed:error.generic",
    NETWORK_ERROR_ALERT: "internet:error.generic",
    CORE_ERROR_TOAST: "core:error.generic",
    TRADING_SERVICE_ERROR_TOAST: "trading-service:error.generic",
    TRADING_SERVICE_ERROR_POPUP_RELOGIN: "trading-service:error.relogin",
    ENTITLEMENT_ERROR_POPUP_RELOGIN: "entitlement-service:error.no-relogin",
    TRADING_SERVICE_ERROR_POPUP_LOGOUT: "trading-service:error.logout",
    TRADING_SERVICE_ERROR_MODAL_LOGOUT: "trading-service:error-modal.logout",
    MARKET_SERVICE_ERROR_TOAST: "market-service:error.generic",
    MARKET_SERVICE_ERROR_TOAST_RETRY: "market-service:error.retry",
    ORDER_CANCELLATIONS: "async:orders.cancellations.error",
    FS_GET_NIGHTLY_REPORTS_ERROR: "socket:fs-nightly-reports:error",
    FS_ORDER_CANCEL_ALL_COMPLETE: "socket:fs-order-cancel-all:error",
  };
  public static successKeys = {
    ALERT_NOTIFICATION_TOAST: "alerting-service:success.generic",
    TRADING_SERVICE_SUCCESS_TOAST: "trading-service:success.generic",
    NETWORK_UP_TOAST: "internet:success.generic",
    TRADING_SERVICE_TOAST_TOP: "trading-service:top.generic",
  };
  public static connectionKeys = {
    CMED_CONNECTION_FAILED: "cmed:connection.failed",
    CMED_CONNECTION_SUCCESS: "cmed:connection.success",
  };
  public static alertKeys = {
    FirmSoftTab: "fs:alert::success",
    TraderCMED: "cmed:alert::success",
  };
  public static errorMessage = {
    REQUEST_ERROR_CMED_TIMEOUT:
      "Your session has expired due to inactivity.Please log back in if you wish to access your account.",
    CMED_SERVICE_UNAVAILABLE: "CMED Service Unavailable",
    CONNECTION_INTERRUPTION:
      "The connection was interrupted. Please reach out to GCC.",
    CMED_TOKEN_UNKNOWN_SQUARE_BRACKETS: "[CmedToken is unknown]",
    CMED_TOKEN_UNKNOWN: "CmedToken is unknown",
    ERROR_MESSAGE_GENERIC: "An unexpected error occurred",
    REQUEST_ERROR_INVALID_PARAMETERS: "Invalid Parameters",
    REQUEST_ERROR_ENTITLEMENT_OR_INVALID_PARAMETERS:
      "There was an entitlement or invalid parameter issue.",
    REQUEST_ERROR_RESPONSE_INVALID_PARAMETERS:
      "There was an invalid parameter issue.",
    MESSAGE_UNAUTH: "message_unauth",
    ERROR_ADD_CONTRACT: "Failed to add contract to group",
    UNAUTHORIZED_USER_MESSAGE:
      "Username / Password combination is incorrect OR the user has not been provisioned for CME Direct.",
  };
}
